import { LoadingIcon } from '@chegg-ui/horizon-icons';
import { colors } from '@chegg-ui/theme';
import React from 'react';
import { UpiProcessingModal, UpiProcessingWrapper } from './styled';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
var UpiProcessing = function UpiProcessing() {
  var _useAppSelector = useAppSelector(configSelector),
    ui = _useAppSelector.ui;
  if (!ui) return null;
  if (!ui.showUpiProcessing) return null;
  return /*#__PURE__*/React.createElement(UpiProcessingWrapper, {
    "aria-label": DataTestAttributes.UPI_PROCESSING,
    id: DataTestAttributes.UPI_PROCESSING,
    "data-test": DataTestAttributes.UPI_PROCESSING,
    "aria-modal": true,
    role: 'dialog'
  }, /*#__PURE__*/React.createElement(UpiProcessingModal, null, /*#__PURE__*/React.createElement(LoadingIcon, {
    "data-test": DataTestAttributes.UPI_PROCESSING_ICON,
    size: "large",
    svgColor: colors.cheggOrange
  })));
};
export default UpiProcessing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/UpiProcessing.js
// module id = 4600
// module chunks = 11